import { asGuiOptions } from "@/models/GuiOptions";

const lang = document.documentElement.lang || 'de';
const node = document.getElementById('app-teres')
const dataset = node && node.dataset || {};



export default {
  language: lang.substring(0, 2),
  baseUrl: dataset.baseUrl || '/',
  baseApiUrl: dataset.baseApiUrl || '/',
  baseResourcesUrl: dataset.baseResourcesUrl || '/',
  interface: asGuiOptions(dataset.interface),
  labelOverride: JSON.parse(dataset.labelOverride || '{}'),
  labelAdminUrl: dataset.labelAdminUrl || '',
  faqUrl: dataset.faqUrl || '',
  recaptchaPublicToken: dataset.recaptchaPublicToken || '',
  recaptchaSrc: dataset.recaptchaSrc || '',
  maxRooms: 999,
  maxTimeSlots: 999,
  maxBlackListEntries: 999,
  maxDailyTickets: 999,
  maxReservations: 5,
  pagingSize: 20,
  timeslotBookableStartValue: 30,
  timeslotBookableEndValue: 2,
}
